import { Card, Typography } from "@mui/material";
import { useTranslations } from "hooks/useTranslations";
import React from "react";
import { sharedStyles } from "./cardStyles";
interface IProps {
  pnr: string;
}
export const ReferenceCard = ({ pnr }: IProps) => {
  const translations = useTranslations().translations;
  const content = translations.confirmationPage;

  return (
    <>
      <Card sx={{ ...sharedStyles.card, mt: 2 }}>
        <Typography sx={sharedStyles.cardHeader} variant="h5">
          {content.reference}
        </Typography>
        <Typography variant="h5">{pnr}</Typography>
      </Card>
    </>
  );
};
